import React from 'react'

const Footer = () => {
    return (
        <footer id="footer" className="footer-area">
     
        {/* <!-- footer widget --> */}
        <div className="footer-copyright pb-20">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="copyright-text text-center pt-20">
                            <p>Copyright © 2021. Designed &amp; Developed By cyberbizkit</p>
                        </div> 
                        {/* <!-- copyright text --> */}
                    </div>
                </div> 
                {/* <!-- row --> */}
            </div> 
            {/* <!-- container --> */}
        </div>
         {/* <!-- footer widget --> */}
    </footer>
    )
}

export default Footer
